import {RoomArea} from '../../types/room'

export const IMPERIAL_UNIT = 'ft²'
export const METRIC_UNIT = 'm²'

/**
 * Returns formatted room area text or null when area is unavailable.
 * @param roomArea - Room area measurements in feet and meters.
 * @param userCountry - User country code used to pick preferred unit.
 * @param showBothUnits - Whether both metric and imperial values should be shown.
 */
export const getRoomAreaWithUnits = (
  roomArea: RoomArea | undefined,
  userCountry: string | undefined,
  showBothUnits: boolean = false
) => {
  if (!roomArea || Object.keys(roomArea).length === 0) return null

  const {squareFeet, squareMeters} = roomArea
  const isImperialRoomAreaCountry = userCountry
    ? ['US', 'UK', 'CA', 'LR', 'MM'].includes(userCountry)
    : false

  const areaUnit = isImperialRoomAreaCountry ? IMPERIAL_UNIT : METRIC_UNIT
  const areaValue = areaUnit === IMPERIAL_UNIT ? squareFeet : squareMeters

  if (!areaValue) return null

  const roundedArea = Math.round(areaValue as number)

  if (!showBothUnits) {
    return `${roundedArea} ${areaUnit}`
  }

  if (!squareFeet || !squareMeters) return null

  const roundedFeet = Math.round(squareFeet as number)
  const roundedMeters = Math.round(squareMeters as number)
  return `${roundedFeet} ${IMPERIAL_UNIT} (${roundedMeters} ${METRIC_UNIT})`
}
